import { Skeleton } from "@/components/Loading/Skeleton.tsx";

const SkeletonTag = ({ width }: { width: number }) => {
  return <Skeleton className={`mr-2 mt-4 h-6 w-${width} rounded-xl`} />;
};

export const LoadingFilterSection = () => {
  return (
    <div className="mb-8">
      <Skeleton className="h-[22px] w-24" />
      <div className="flex flex-wrap">
        <SkeletonTag width={32} />
        <SkeletonTag width={24} />
        <SkeletonTag width={32} />
        <SkeletonTag width={24} />
        <SkeletonTag width={32} />
        <SkeletonTag width={32} />
      </div>
    </div>
  );
};
